import { Button, DataSource, HorizontalSpacer, Image, Label, Layout, Panel, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEdiRawDataSlideout extends Layout {
    buttonDownloadBilling: Button;
    buttonDownloadFuncAck: Button;
    buttonDownloadInterchange: Button;
    buttonDownloadReply: Button;
    buttonDownloadStatus: Button;
    buttonDownloadTender: Button;
    buttonEDIToEnglish: Button;
    buttonRawData: Button;
    horizontalspacerBillingEngligh: HorizontalSpacer;
    horizontalspacerCopyRawData1: HorizontalSpacer;
    horizontalspacerCopyRawData2: HorizontalSpacer;
    horizontalspacerCopyRawData3: HorizontalSpacer;
    horizontalspacerCopyRawData4: HorizontalSpacer;
    horizontalspacerCopyRawData5: HorizontalSpacer;
    horizontalspacerCopyRawData6: HorizontalSpacer;
    horizontalspacerCopyRawData7: HorizontalSpacer;
    horizontalspacerCopyRawDataBilling: HorizontalSpacer;
    horizontalspacerFuncAck: HorizontalSpacer;
    horizontalspacerInterchange: HorizontalSpacer;
    horizontalspacerRawBilling: HorizontalSpacer;
    horizontalspacerRawReply: HorizontalSpacer;
    horizontalspacerRawStatus: HorizontalSpacer;
    horizontalspacerRawTender: HorizontalSpacer;
    horizontalspacerReplyEnglish: HorizontalSpacer;
    horizontalspacerStatusEngligh: HorizontalSpacer;
    horizontalspacerTenderEnglish: HorizontalSpacer;
    imageCopyRawData1: Image;
    imageCopyRawData2: Image;
    imageCopyRawData3: Image;
    imageCopyRawData4: Image;
    imageCopyRawData5: Image;
    imageCopyRawData6: Image;
    imageCopyRawData7: Image;
    imageCopyRawDataBilling: Image;
    labelCopyRawData1: Label;
    labelCopyRawData2: Label;
    labelCopyRawData3: Label;
    labelCopyRawData4: Label;
    labelCopyRawData5: Label;
    labelCopyRawData6: Label;
    labelCopyRawData7: Label;
    labelCopyRawDataBilling: Label;
    labelDatafusionToEnglish: Label;
    labelGeneratedData: Label;
    labelGeneratedDataBilling: Label;
    labelGeneratedDataReply: Label;
    labelGeneratedDataStatus: Label;
    labelRawData: Label;
    panelBillingEnglish: Panel;
    panelBillingPdf: Panel;
    panelBillingRawData: Panel;
    panelCopyRawData1: Panel;
    panelCopyRawData2: Panel;
    panelCopyRawData3: Panel;
    panelCopyRawData4: Panel;
    panelCopyRawData5: Panel;
    panelCopyRawData6: Panel;
    panelCopyRawData7: Panel;
    panelCopyRawDataBilling: Panel;
    panelFuncAck: Panel;
    panelFuncAckPdf: Panel;
    panelFunctionalAckEnglish: Panel;
    panelFunctionalData: Panel;
    panelInterchange: Panel;
    panelInterchangeEnglish: Panel;
    panelInterchangePdf: Panel;
    panelPdf: Panel;
    panelReplyEnglish: Panel;
    panelReplyPdf: Panel;
    panelReplyRawData: Panel;
    panelStatus: Panel;
    panelStatusEnglish: Panel;
    panelStatusPdf: Panel;
    panelTenderEnglish: Panel;
    panelTenderRawData: Panel;
    panelTransactionSet: Panel;
    sourceEdiRawData: DataSource;
    sourceEdiToEnglish: DataSource;
    tabBillingEnglish: Tab;
    tabBillingErrors: Tab;
    tabDatafusionInterchange: Tab;
    tabDatafusionToEnglish: Tab;
    tabEdiBilling: Tab;
    tabErrors: Tab;
    tabFunctionalAck: Tab;
    tabFunctionalAckEnglish: Tab;
    tabFunctionalData: Tab;
    tabInterchange: Tab;
    tabRawData: Tab;
    tabReply: Tab;
    tabReplyEnglish: Tab;
    tabReplyErrors: Tab;
    tabStatus: Tab;
    tabStatusEnglish: Tab;
    tabStatusErrors: Tab;
    tabTab1: Tab;
    tabTabFunc1: Tab;
    tabTender: Tab;
    tabTenderEnglish: Tab;
    tabTransactionSet: Tab;
    tableBillingErrors: Table;
    tableReplyErrors: Table;
    tableStatusErrors: Table;
    tableTenderErrors: Table;
    tabsetBillingErrors: Tabset;
    tabsetEDItoEnglish: Tabset;
    tabsetErrors: Tabset;
    tabsetFunctionalData: Tabset;
    tabsetRawData: Tabset;
    tabsetRawDataPanels: Tabset;
    tabsetReplyErrors: Tabset;
    tabsetStatusErrors: Tabset;
    tabsetTransactionSet: Tabset;
    textboxBillingRawData: Textbox;
    textboxFuncAckRawData: Textbox;
    textboxInterchangeRawData: Textbox;
    textboxReplyRawData: Textbox;
    textboxStatusRawData: Textbox;
    textboxTenderRawData: Textbox;
}
